import {put, call, all} from 'redux-saga/effects';
import {gql} from '@apollo/client';

import apolloClient from '../apolloClient';
import * as actions from '../actions';

/**
 * Sagas handler for fetching user data.
 */
export default function* getUserData() {
  const userGql = gql`
    {
      ssoUser
      subscriptionsAccess
    }
  `;
  const userData = yield call(apolloClient.query, {
    query: userGql,
  });

  yield all([
    put(actions.updateUserData(userData.data.ssoUser)),
    put(actions.setSubscriptionsSettings(userData.data.subscriptionsAccess)),
  ]);
}
